
import { Injectable } from '@angular/core';
import { DialogService } from './dialog.service';
import { Globals } from 'src/app/shared/helpers/globals';
import { Ordem } from '../model/ordem';
@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {
  constructor(
    private dialogService: DialogService,
    private globals: Globals
  ) {}

  handle(error: any): void {
    if (error?.error?.code == 412) {
      const ordem: Ordem = error.error.ordemDuplicada;
      this.dialogService.showOrdemEmAtendimentoDialog(ordem);
    } else if (Array.isArray(error?.error) && error.error[0]?.code == 400)
      this.globals.showSnackBar(error.error[0].message);
    else
      this.globals.showSnackBar("Algo de errado aconteceu, por favor, tente novamente mais tarde.");
  }
}
